import initialState from "./initialState";

export const types = {
  reset: "reset",
  SET_TIME_DATA: "SET_TIME_DATA",
  SET_ACTIVE_TIME_SLICE: "SET_ACTIVE_TIME_SLICE",
  SET_ACTIVE_TIME_WINDOW: "SET_ACTIVE_TIME_WINDOW",
  SET_MAX_TIME: "SET_MAX_TIME",
  SET_SHOW_TIME_FILTERS: "SET_SHOW_TIME_FILTERS",
  SET_ACTIVE_DAYS: "SET_ACTIVE_DAYS",
  SET_ACTIVE_PEAKS: "SET_ACTIVE_PEAKS",
  SET_SHOW_BOTTOM_PANEL: "SET_SHOW_BOTTOM_PANEL",
};

export default {
  [types.reset]: state => {
    Object.keys(initialState()).forEach(key => {
      state[key] = initialState()[key];
    });
  },
  [types.SET_TIME_DATA]: (state, data) => {
    state.timeData = data;
  },
  [types.SET_ACTIVE_TIME_SLICE]: (state, data) => {
    state.activeTimeSlice = data;
  },
  [types.SET_ACTIVE_TIME_WINDOW]: (state, data) => {
    state.activeTimeSlice = {};
    state.activeTimeWindow = data;
  },
  [types.SET_MAX_TIME]: (state, data) => {
    state.maxtime = data;
  },
  [types.SET_SHOW_TIME_FILTERS]: (state, data) => {
    state.showTimeFilters = data;
  },
  [types.SET_ACTIVE_DAYS]: (state, data) => {
    state.activeDays = data;
  },
  [types.SET_ACTIVE_PEAKS]: (state, data) => {
    state.activePeaks = data;
  },
  [types.SET_SHOW_BOTTOM_PANEL]: (state, data) => {
    state.showBottomPanel = data;
  },
};
